import React from 'react';
const SubHeader = ({
  leftContent = null,
  rightContent = null
}) => /*#__PURE__*/React.createElement("div", {
  className: "ebds-navigation__sub-header__wrapper"
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-navigation__sub-header"
}, /*#__PURE__*/React.createElement("div", {
  className: "ebds-navigation__sub-header__left-content"
}, leftContent), /*#__PURE__*/React.createElement("div", {
  className: "ebds-navigation__sub-header__right-content"
}, rightContent)));
export default SubHeader;